import helpers from "../utils/helpers";

const ProductReturn = {
  init() {
    const form = $("#product-return-form");
    if (!form.length) {
      return;
    }

    form.on("submit", function (e) {
      e.preventDefault();

      const formEl = $(this);
      $(".error", this).removeClass("error");

      if (ProductReturn.validate(formEl)) {
        formEl.addClass("loading");
        setTimeout(function () {
          ProductReturn.submitForm(formEl);
        }, 500);
      } else {
        formEl.removeClass("loading");
      }
    });
  },

  validate(form) {
    let errors = [];
    const inputs = form.find("input.required, select.required, textarea.required").not(".disabled");

    inputs.each(function () {
      const input = $(this);

      if (input.is(":checkbox")) {
        if (!input.is(":checked")) {
          input.addClass("error");
          errors.push(translations.field_required);
        } else {
          input.removeClass("error");
        }
        return;
      }

      if (input.val() === "" || input.val() === "0") {
        input.addClass("error");
        errors.push(translations.field_required);
        return;
      }

      input.removeClass("error");

      if (input.attr("type") === "email" || input.hasClass("email")) {
        if (!helpers.is_valid_email(input.val())) {
          input.addClass("error");
          errors.push(translations.valid_email);
        }
      }
    });

    if (errors.length) {
      form.addClass("errors");
      return false;
    }

    form.removeClass("errors");
    return true;
  },

  submitForm(formEl) {
    if (typeof grecaptcha === "undefined") {
      ProductReturn.showError(
        formEl,
        translations.valid_captcha || "reCAPTCHA kļūme, lūdzu mēģiniet vēlreiz"
      );
      return;
    }

    grecaptcha.ready(function () {
      grecaptcha
        .execute(recaptcha_site_key, {
          action: "contact",
        })
        .then(function (token) {
          ProductReturn.sendFormData(formEl, token);
        })
        .catch(function () {
          ProductReturn.showError(
            formEl,
            translations.valid_captcha || "reCAPTCHA kļūme, lūdzu mēģiniet vēlreiz"
          );
        });
    });
  },

  showError(formEl, message) {
    formEl.removeClass("loading");
    formEl.find("button").removeClass("loading");
    formEl
      .find(".form__status")
      .addClass("error")
      .text(message)
      .removeClass("hidden");
  },

  sendFormData(formEl, token) {
    formEl.find("button").addClass("loading");
    formEl.find(".form__status").addClass("hidden");

    const form_data = {
      full_name: formEl.find('[name="full_name"]').val(),
      email: formEl.find('[name="email"]').val(),
      telephone: formEl.find('[name="telephone"]').val(),
      order_number: formEl.find('[name="order_number"]').val(),
      order_date: formEl.find('[name="order_date"]').val(),
      message: formEl.find('[name="message"]').val(),
    };

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "product_return_form",
        form_data: form_data,
        token: token,
        post_id: formEl.find('[name="post_id"]').val(),
        nonce: formEl.find("#product-return-nonce").val(),
        honey: formEl.find('[name="honey"]').val(),
        terms: formEl.find('[name="terms"]').is(":checked") ? "yes" : "",
      },
    })
      .done(function (response) {
        if (response.success) {
          formEl.find(".errors-wrap").remove();
          formEl
            .find(".form__status")
            .removeClass("error")
            .text(response.data.message)
            .removeClass("hidden");
          formEl[0].reset();
          formEl.find("input, textarea").blur();
        } else {
          formEl
            .find(".form__status")
            .addClass("error")
            .text(response.data.message)
            .removeClass("hidden");
        }
      })
      .always(function () {
        formEl.removeClass("loading");
        formEl.find("button").removeClass("loading");
      })
      .fail(function () {
        ProductReturn.showError(
          formEl,
          translations.required || "Kļūda nosūtot formu, provē mazliet vēlāk velreiz."
        );
      });
  },
};

export default ProductReturn;
